import Notifications from "@/views/systerm/adminConfig/notifications.vue"; //流程配置
import Integration from "@/views/systerm/adminConfig/Integration.vue"; //流程配置
import Preference from "@/views/systerm/adminConfig/Preference.vue"; //流程配置

export const AdminConfig = [
  {
    path: "/notifications",
    component: Notifications,
    name: "Notifications",
  },
  {
    path: "/Integration",
    component: Integration,
    name: "Integration",
  },
  {
    path: "/preference",
    component: Preference,
    name: "Preference",
  },
  {
    path: "/calendar",
    component: () => import("@/views/systerm/adminConfig/calendar.vue"),
  },
];
